/*
 * @Author: youfanrong 737064439@qq.com
 * @Date: 2025-03-03 08:59:07
 * @LastEditors: youfanrong 737064439@qq.com
 * @LastEditTime: 2025-04-21 12:10:37
 * @FilePath: /bar-front-end/src/axios/config.ts
 */
import { AxiosResponse, InternalAxiosRequestConfig } from './types'
import { ElMessage } from 'element-plus'
import qs from 'qs'
import { SUCCESS_CODE, TRANSFORM_REQUEST_DATA } from '@/constants'
import { useUserStoreWithOut } from '@/store/modules/user'
import { objToFormData } from '@/utils'

const defaultRequestInterceptors = (config: InternalAxiosRequestConfig) => {
  if (
    config.method === 'post' &&
    config.headers['Content-Type'] === 'application/x-www-form-urlencoded'
  ) {
    config.data = qs.stringify(config.data)
  } else if (
    TRANSFORM_REQUEST_DATA &&
    config.method === 'post' &&
    config.headers['Content-Type'] === 'multipart/form-data' &&
    !(config.data instanceof FormData)
  ) {
    config.data = objToFormData(config.data)
  }
  if (config.method === 'get' && config.params) {
    let url = config.url as string
    url += '?'
    const keys = Object.keys(config.params)
    for (const key of keys) {
      const val = config.params[key]
      if (val !== void 0 && val !== null) {
        if (Array.isArray(val)) {
          for (const item of val) {
            url += `${key}=${encodeURIComponent(item)}&`
          }
        } else {
          url += `${key}=${encodeURIComponent(val)}&`
        }
      }
    }
    url = url.substring(0, url.length - 1)
    config.params = {}
    config.url = url
  }
  return config
}

const defaultResponseInterceptors = (response: AxiosResponse) => {
  if (response?.config?.responseType === 'blob') {
    // 如果是文件流，直接过
    return response
  } else if (response.data.code === SUCCESS_CODE || response.data.code === 0) {
    // 为调试添加code=0, 正式环境添加code=200
    return response.data
  } else if (response.data.code === 10010) {
    // 延期code码，不需要全局提示
    return response.data
  } else {
    ElMessage.error(response?.data?.msg)
    if (response?.data?.code === 10003) {
      const userStore = useUserStoreWithOut()
      userStore.logout()
    }
    return response.data // 确保失败时也返回数据
  }
}

export { defaultResponseInterceptors, defaultRequestInterceptors }
